
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-card/california",
      function () {
        return require("private-next-pages/medical-card/california.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-card/california"])
      });
    }
  